
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/singing-portraits",
      function () {
        return require("private-next-pages/singing-portraits/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/singing-portraits"])
      });
    }
  